module.exports = __webpack_public_path__ + "img/vin-back.png";